import {generalService} from '../../helpers/generalService';

export const state = {
    getGeneralData : [],
}
export const mutations = {
    getGeneralData(state, payload) {
        state.getGeneralData = payload;
        state.loading = true;
        state.pagination = payload;
        state.userCount = payload;
    },
}
export const actions = {
    async updateGeneralData({dispatch, commit}, data) {
        let token = JSON.parse(localStorage.getItem('token'));
        window.axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return new Promise((resolve) => {
            generalService.updateGeneralData(data)
            .then(
                response => {
                    commit('getGeneralData', response.data);
                    resolve(response);
                },
                error => {
                    dispatch("alert/error", error, {root: true});
                }
            );
        })
    },
}
export const getters = {
    getGeneralData: state => state.getGeneralData,
    loading: state => state.loading,
    userCount: state => state.userCount,
    pagination: state => state.pagination
};